import React from 'react'

import {
    Table,
    Paper,
    TableRow,
    TableCell,
    TableBody,
    TableFooter,
    FormControl,
    TableContainer,
    TablePagination,
} from '@mui/material'

import { TableHeadStyled, TableRowStyled } from './style'
import toCurrency from '../../utils/toCurrency'
import dateFormat from '../../utils/dateFormat'
import { mediumGray, paragraph } from '../../variables'

export default function TableFornecedor({ nfes, count, page, onPageChange, rowsPerPage, total }) {
    return (
        <FormControl>
            <TableContainer
                component={Paper}
                sx={{
                    borderRadius: '10px'
                }}
            >
                <Table
                    aria-label="Tabela"
                >
                    <TableHeadStyled>
                        <TableRow>
                            <TablePagination
                                count={count}
                                page={page}
                                onPageChange={onPageChange}
                                rowsPerPage={rowsPerPage}
                                rowsPerPageOptions={[rowsPerPage]}
                                total={total}
                                labelDisplayedRows={({ from, to, count }) => {
                                    return `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`} itens`;
                                }}
                                sx={{
                                    '& .MuiTablePagination-displayedRows': {
                                        fontSize: '1em',
                                    }
                                }}
                            />
                        </TableRow>
                        <TableRow>
                            <TableCell align="left">
                                Número
                            </TableCell>
                            <TableCell align="left">
                                Data/Hora
                            </TableCell>
                            <TableCell align="left">
                                Fornecedor
                            </TableCell>
                            <TableCell align="left">
                                Chave de Acesso
                            </TableCell>
                            <TableCell align="right">
                                Valor
                            </TableCell>
                        </TableRow>
                    </TableHeadStyled>
                    <TableBody>
                        {nfes.map(nfe => (
                            <TableRowStyled
                                key={nfe.chaveAcesso}
                            >
                                <TableCell>
                                    {nfe.numeroDoPedido ? nfe.numeroDoPedido : 'N/A'}
                                </TableCell>
                                <TableCell>
                                    {dateFormat(nfe.dataEmissao)}
                                </TableCell>
                                <TableCell>
                                    {nfe.nomeFornecedor ? nfe.nomeFornecedor : 'N/A'}
                                </TableCell>
                                <TableCell>
                                    {nfe.chaveAcesso ? nfe.chaveAcesso : 'N/A'}
                                </TableCell>
                                <TableCell align="right">
                                    {toCurrency('BRL', nfe.valor)}
                                </TableCell>
                            </TableRowStyled>
                        ))}
                    </TableBody>
                    <TableFooter>
                        <TableRow
                            sx={{
                                borderTop: '1px solid rgba(224, 224, 224, 1)',
                            }}
                        >
                            <TableCell
                                colSpan={4}
                                align="right"
                                sx={{
                                    fontWeight: 700,
                                    color: `${mediumGray}`,
                                    fontSize: `${paragraph}`
                                }}
                            >
                                Total
                            </TableCell>
                            <TableCell
                                align="right"
                                sx={{
                                    fontSize: `${paragraph}`
                                }}
                            >
                                {toCurrency('BRL', Number(total))}
                            </TableCell>
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        </FormControl>
    )
}